import { ChevronRight } from 'lucide-react';
import styled from 'styled-components';

import { UsuarioInterno } from '../../../../types/usuario';
import { formatDateTime, summarizePermissions } from './format';
import { UserStatusBadge } from './user-status-badge';

interface Props {
  items: UsuarioInterno[];
  onOpenDetail: (id: string) => void;
}

const List = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const Item = styled.li`
  background: ${({ theme }) => theme.colors.bgSurface};
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: ${({ theme }) => theme.radius.lg};
`;

const Card = styled.button`
  width: 100%;
  text-align: left;
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 8px;
  padding: 16px;
  background: transparent;
  border: none;
  border-radius: inherit;
  cursor: pointer;
  color: inherit;

  &:hover {
    background: ${({ theme }) => theme.colors.bgMuted};
  }
`;

const Top = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  grid-column: 1 / -1;
`;

const Info = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  line-height: 1.3;

  strong {
    font-weight: 600;
  }

  small {
    color: ${({ theme }) => theme.colors.textMuted};
    font-size: 12.5px;
  }
`;

const Meta = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12.5px;
  color: ${({ theme }) => theme.colors.textMuted};
  margin-top: 4px;
`;

export const UsuariosCards = ({ items, onOpenDetail }: Props) => (
  <List>
    {items.map((user) => (
      <Item key={user.id}>
        <Card
          onClick={() => onOpenDetail(user.id)}
          data-testid={`user-card-${user.id}`}
        >
          <Top>
            <Info>
              <strong>{user.name}</strong>
              <small>{user.email}</small>
            </Info>
            <UserStatusBadge active={user.active} />
          </Top>
          <Info>
            <span>{summarizePermissions(user.permissions)}</span>
          </Info>
          <Meta>
            <span>Último login: {formatDateTime(user.lastLoginAt)}</span>
            <ChevronRight size={16} />
          </Meta>
        </Card>
      </Item>
    ))}
  </List>
);
